/**
 * Central invalidation for meal-domain mutations.
 */
import type { QueryClient } from '@tanstack/react-query';
import { applyInvalidation } from './applyInvalidation';
import type { InvalidationRuleId } from './invalidateRegistry';

export type RunInvalidationInput = {
  rule_id: InvalidationRuleId;
  customer_id: number;
  date?: string;
  dates?: string[];
};

export async function runInvalidationForMutation(
  query_client: QueryClient,
  input: RunInvalidationInput,
): Promise<void> {
  await applyInvalidation(query_client, input.rule_id, {
    customer_id: input.customer_id,
    date: input.date,
    dates: input.dates,
  });
}
